import { render, staticRenderFns } from "./GraphDetail66.vue?vue&type=template&id=1231bcd2&scoped=true"
import script from "./GraphDetail66.vue?vue&type=script&lang=js"
export * from "./GraphDetail66.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1231bcd2",
  null
  
)

export default component.exports